module.exports = __webpack_public_path__ + "img/PRCFLogo - Lite.621818a6.png";